import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/ServicesGrid/ServicesGrid.js
const ServicesGrid = createSectionForm({
  icon: "tools-line",
  title: "Services Grid",
  fields: [
    { name: "title", label: "Section Title" },
    {
      name: "services",
      label: "Services",
      type: "list",
      itemLabel: "Service",
      fields: [
        { name: "image", label: "Image", type: "media" },
        { name: "name", label: "Name", placeholder: "e.g. Radio Repair" },
        { name: "link", label: "Link", type: "link" },
      ],
    },
  ],
});

export default ServicesGrid;
